'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodashCompat = require('lodash-compat');

var _lodashCompat2 = _interopRequireDefault(_lodashCompat);

var _strftime = require('strftime');

var _strftime2 = _interopRequireDefault(_strftime);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

Function.prototype.$asyncbind = function $asyncbind(self, catcher) {
  var resolver = this;

  if (catcher === true) {
    if (!Function.prototype.$asyncbind.EagerThenable) Function.prototype.$asyncbind.EagerThenable = function factory(tick) {
      var _tasks = [];

      if (!tick) {
        try {
          tick = process.nextTick;
        } catch (ex) {
          tick = function tick(p) {
            setTimeout(p, 0);
          };
        }
      }

      function _untask() {
        for (var i = 0; i < _tasks.length; i += 2) {
          var t = _tasks[i + 1],
              r = _tasks[i];

          for (var j = 0; j < t.length; j++) {
            t[j].call(null, r);
          }
        }

        _tasks = [];
      }

      function isThenable(obj) {
        return obj && obj instanceof Object && typeof obj.then === 'function';
      }

      function EagerThenable(resolver) {
        function done(inline) {
          var w;
          if (_sync || phase < 0 || (w = _thens[phase]).length === 0) return;

          _tasks.push(result, w);

          _thens = [[], []];
          if (_tasks.length === 2) inline ? _untask() : tick(_untask);
        }

        function resolveThen(x) {
          if (isThenable(x)) return x.then(resolveThen, rejectThen);
          phase = 0;
          result = x;
          done(true);
        }

        function rejectThen(x) {
          if (isThenable(x)) return x.then(resolveThen, rejectThen);
          phase = 1;
          result = x;
          done(true);
        }

        function settler(resolver, rejecter) {
          _thens[0].push(resolver);

          _thens[1].push(rejecter);

          done();
        }

        function toString() {
          return 'EagerThenable{' + {
            '-1': 'pending',
            0: 'resolved',
            1: 'rejected'
          }[phase] + '}=' + result.toString();
        }

        this.then = settler;
        this.toString = toString;
        var _thens = [[], []],
            _sync = true,
            phase = -1,
            result;
        resolver.call(null, resolveThen, rejectThen);
        _sync = false;
        done();
      }

      EagerThenable.resolve = function (v) {
        return isThenable(v) ? v : {
          then: function then(resolve, reject) {
            return resolve(v);
          }
        };
      };

      return EagerThenable;
    }();
    return new Function.prototype.$asyncbind.EagerThenable(boundThen);
  }

  if (catcher) {
    if (Function.prototype.$asyncbind.wrapAsyncStack) catcher = Function.prototype.$asyncbind.wrapAsyncStack(catcher);
    return then;
  }

  function then(result, error) {
    try {
      return result && result instanceof Object && typeof result.then === 'function' ? result.then(then, catcher) : resolver.call(self, result, error || catcher);
    } catch (ex) {
      return (error || catcher)(ex);
    }
  }

  function boundThen(result, error) {
    return resolver.call(self, result, error);
  }

  boundThen.then = boundThen;
  return boundThen;
};

function format(timestamp) {
  var pattern = arguments.length <= 1 || arguments[1] === undefined ? 'yyyy-mm-dd' : arguments[1];

  if (timestamp == null || timestamp === '' || !_lodashCompat2.default.isFinite(+timestamp)) {
    return "";
  }

  var date = new Date();
  date.setTime(timestamp);

  // 检查format, 不满足则使用新语法(strftime)
  // 支持格式 yyyy-mm-dd, yyyy/mm/dd, yyyy-mm, yyyy/mm
  // hh:MM:ss, yyyy-mm-dd hh:MM:ss, yyyy/mm/dd hh:MM:ss
  if (!/^yyyy(-|\/)mm(\1dd( hh:MM:ss)?)?|hh:MM:ss$/.test(pattern)) {
    return (0, _strftime2.default)(pattern, date);
  }

  // 如果有 日期 信息
  if (pattern.search(/yyyy/) != -1) {
    var separator = pattern.charAt(4);
    var patterntedDate = date.getFullYear() + separator + _toTwoDigit(date.getMonth() + 1);

    // 如果有 日 信息
    if (pattern.search(/dd/) != -1) {
      patterntedDate += separator + _toTwoDigit(date.getDate());
    }

    // 如果包含时间信息
    if (pattern.search(/hh:MM:ss/) != -1) {
      patterntedDate += " " + _getTime(date);
    }
  } else {
    // 只有时间信息
    return _getTime(date);
  }

  return patterntedDate;
}

function parse(str, format) {
  // 检查format, 不满足则为默认值 yyyy-mm-dd
  // 支持格式 yyyy-mm-dd, yyyy/mm/dd, yyyy-mm, yyyy/mm
  // yyyy-mm-dd hh:MM:ss, yyyy/mm/dd hh:MM:ss
  if (!/^yyyy(-|\/)mm(\1dd( hh:MM:ss)?)?$/.test(format)) {
    format = "yyyy-mm-dd";
  }

  //要求str与format的格式一致
  var regExp = new RegExp("^" + format.replace(/\w/g, "\\d") + "$");
  if (!regExp.test(str)) {
    throw new Error(str + " 不符合 " + format);
  }

  var date = new Date(1970, 0, 2, 0, 0, 0);

  var separator = format.charAt(4);
  var datePart = str.split(separator);

  if (format.search(/hh:MM:ss/) != -1) {
    var fields = str.split(' ');
    datePart = fields[0].split(separator);
    var timePart = fields[1].split(':');

    date.setHours(Number(timePart[0]));
    date.setMinutes(Number(timePart[1]));
    date.setSeconds(Number(timePart[2]));
  }

  date.setFullYear(Number(datePart[0]));
  date.setMonth(Number(datePart[1]) - 1);
  date.setDate(1);

  // 如果有 日 信息
  if (format.search(/dd/) != -1) {
    date.setDate(Number(datePart[2]));
  }

  return date.getTime();
}

function _toTwoDigit(v) {
  return ('0' + v).slice(-2);
}

function _getTime(date) {
  return _toTwoDigit(date.getHours()) + ':' + _toTwoDigit(date.getMinutes()) + ':' + _toTwoDigit(date.getSeconds());
}

exports.default = { format: format, parse: parse };